import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { Links } from "../../helpers/Links";
import { ChiTietThanhLyTaiSan as ChiTietThanhLyTaiSanModel } from "../../models/taisan/ThanhLyTaiSan";
import LoadingDetailPage from "../../modules/loading/LoadingDetailPage";
import { layChiTietPhieuThanhLy } from "../../services/thanhlytaisan";
import LuuThanhLyTaiSanBox from "./LuuThanhLyTaiSanBox";

const ChiTietThanhLyTaiSan = () => {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");

    const [isLoading, setIsLoading] = useState(false);
    const [reloadPage, setReloadPage] = useState(false);
    const [phieu, setPhieu] = useState<ChiTietThanhLyTaiSanModel | null>(null);

    const loadChiTiet = async () => {
        if (!id) {
            setPhieu(null);
            return;
        }

        try {
            setIsLoading(true);
            const result = await layChiTietPhieuThanhLy(parseInt(id));
            setPhieu(result);
        } catch (error: any) {
            toast.error("Lỗi khi tải chi tiết phiếu thanh lý: " + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = (savedId: number, action: "draft" | "ghigiam" | "complete") => {
        if (action === "draft") {
            navigate(`${Links.ThanhLyTaiSan.ChiTiet}?id=${savedId}`);
            setReloadPage(true);
            return;
        }

        navigate(`${Links.ThanhLyTaiSan.Xem}?id=${savedId}`);
    };

    useEffect(() => {
        if (reloadPage) {
            setReloadPage(false);
            loadChiTiet();
        }
    }, [reloadPage]);

    useEffect(() => {
        loadChiTiet();
    }, [id]);

    if (isLoading) {
        return <LoadingDetailPage title={id ? "Sửa phiếu thanh lý tài sản" : "Thêm phiếu thanh lý tài sản"} />;
    }

    return (
        <section>
            <ContentHeader title={id ? "Sửa phiếu thanh lý tài sản" : "Thêm phiếu thanh lý tài sản"} />
            <div className="container-fluid">
                <div className="card">
                    <div className="card-body">
                        <LuuThanhLyTaiSanBox modelProps={phieu} onSubmit={handleSubmit} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ChiTietThanhLyTaiSan;
